import { motion } from "framer-motion";

export default function StatsSection() {
  return (
    <section className="py-24 px-6 md:px-12 relative" data-testid="stats-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h2 className="font-playfair text-4xl md:text-6xl font-bold mb-8">
            <span className="gold-gradient-text" data-testid="stats-heading">
              Our Impact
            </span>
          </h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-manrope text-white/90 text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed"
          >
            We helped hundreds of businesses and individuals get funded successfully and we want you or your business to be our next success story!
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}